import { AnalyticsItemsEvent } from './CombinedGAPiwik';

type GTagArg = Array<any>;

export type GTag = (...args: GTagArg) => void;

declare global {
   interface Window {
      gtag?: GTag;
      dataLayer?: GTagArg;
   }
}

function gtag(...args: GTagArg) {
   // eslint-disable-next-line no-console
   console.log('gtag', gtag);
   if (window.gtag) {
      window.gtag(...args);
   }
}

export function trackGA4ViewCart(event: AnalyticsItemsEvent) {
   gtag('event', 'view_cart', event);
}

export function trackGA4AddToCart(event: AnalyticsItemsEvent) {
   gtag('event', 'add_to_cart', event);
}

export function trackGA4RemoveFromCart(event: AnalyticsItemsEvent) {
   gtag('event', 'remove_from_cart', event);
}
